import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Archive2022 } from '../ScintillaOfArt/components';
import { Sidebar2025 } from '../SEWA/components';


const Sramdhan2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/6.webp`;
    const p7 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/7.webp`;
    const p8 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/8.webp`;
    const p9 = `${config.base_image_url_2025}/home/events-activities/sewa/SRAMDHAM2025/9.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 2,
            cols: 2,
        },
        {
            src: p2,
            source: p2,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p3,
            source: p3,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p4,
            source: p4,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p5,
            source: p5,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p6,
            source: p6,
            rows: 2,
            cols: 1.5,
        },
        {
            src: p7,
            source: p7,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p8,
            source: p8,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p9,
            source: p9,
            rows: 1.5,
            cols: 2,
        }

    ];

    return (
         <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            
                            <Box >
                                <Typography variant='h4' align='center' >
                                    <div>SRAMDHAN</div>
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Date: 6 December 2025
                                </Typography>
                             
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                As part of the SEWA (Social Empowerment through Work Education and Action) programme, Class 12 students hosted a meaningful event, ‘Sramdhan,’ on Saturday, 6 December 2025, to pay tribute and express profound gratitude to the auxiliary staff for their unwavering dedication and invaluable contributions throughout their schooling years. The initiative sought to honour their tireless service and reassure them of their genuine value. The occasion radiated warmth and heartfelt gratitude, as the students humbly sought the blessings of the auxiliary staff for their journey ahead. Demonstrating commendable initiative and unity, the students delivered a note of gratitude and served lunch, making the day truly significant and memorable.
                                    <br></br>
                                </Typography>
                            </Box>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default Sramdhan2025;